module.exports = {"450924100":"石南镇","450924101":"大平山镇","450924102":"葵阳镇","450924103":"城隍镇","450924104":"山心镇","450924105":"沙塘镇","450924106":"蒲塘镇","450924107":"北市镇","450924108":"龙安镇","450924109":"高峰镇","450924110":"小平山镇","450924111":"卖酒镇","450924112":"洛阳镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450924.json
// module id = 1964
// module chunks = 0